import { type TFunction } from 'i18next';

// These are used to set the key for the dropdown items so that a device that functions
// as both an input and output device can be selected in the dropdown separately.
export const getInputDeviceKeyForDeviceId = (deviceId: string) => `input-${deviceId}`;
export const getOutputDeviceKeyForDeviceId = (deviceId: string) => `output-${deviceId}`;
export const getDeviceIdFromDropdownItemKey = (key: string) => key.replace('input-', '').replace('output-', '');

export const getDeviceLabel = ({ device, t }: { device: MediaDeviceInfo; t: TFunction }) => {
    if (device.deviceId === 'default' && !device.label) return t('default');
    return device.label || t('audioDevice');
};

export const getDropdownItemsForDevices = ({
    type,
    devices,
    t,
    activeDeviceId,
}: {
    type: 'input' | 'output';
    devices: MediaDeviceInfo[];
    t: TFunction;
    activeDeviceId: string;
}) =>
    devices
        // More info on this ticket: https://trello.com/c/e48IcQv7
        .filter(device => device.label !== 'Headset earpiece')
        .map(device => ({
            key:
                type === 'input'
                    ? getInputDeviceKeyForDeviceId(device.deviceId)
                    : getOutputDeviceKeyForDeviceId(device.deviceId),
            label: getDeviceLabel({ device, t }),
            isReadOnly: activeDeviceId === device.deviceId,
        }));
